import React from 'react';
import { IServiceProps, Service } from './Service';
import VisibilitySensor from 'react-visibility-sensor';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import {
  Navigation,
  NavigationItem,
  ServicesSection,
  ServicesSectionInner,
  ServicesSlides,
} from './service.style';
import { useServices } from './services.hooks';

export interface IServicesProps {
  services: IServiceProps[];
}

export const Services = ({ services }: IServicesProps): JSX.Element => {
  const {
    navElementRef,
    servicesTitles,
    activeService,
    clickNavigationItemHandle,
    onVisibleSlideChange,
    windowSize,
    servicesRef,
  } = useServices({ services });

  return (
    <ServicesSection>
      <ServicesSectionInner>
        <Navigation ref={navElementRef}>
          {servicesTitles &&
            servicesTitles.map((item: Array<RichTextBlock>, index: number) => {
              return (
                <NavigationItem
                  key={RichText.asText(item) + index}
                  onClick={(evt) => clickNavigationItemHandle(index)}
                  isActive={activeService === index}
                >
                  {RichText.asText(item)}
                </NavigationItem>
              );
            })}
        </Navigation>
        <ServicesSlides ref={servicesRef}>
          {services.map((service, index: number) => (
            <VisibilitySensor
              minTopValue={
                windowSize.height && windowSize.height > 800 ? 700 : 300
              }
              key={index}
              partialVisibility={'top' as any}
              onChange={(visible) => {
                onVisibleSlideChange(visible, index);
              }}
            >
              <Service
                {...service}
                offset={index}
                activeStep={activeService === index}
                navigationItems={servicesTitles}
              />
            </VisibilitySensor>
          ))}
        </ServicesSlides>
      </ServicesSectionInner>
    </ServicesSection>
  );
};
